import { Tool } from './tool';
import { LevelDesignerComponent } from '../level-designer/level-designer.component';
import { MoveManager } from '../managers/move-manager';
import { VisualTool } from './tool-base-types';
import { ToolType } from './tool';
import { ToolGroup } from './tool-group';

export class ToggleSnappingTool extends VisualTool {
    private moveManager: MoveManager | null = null;

    constructor(canvas: HTMLCanvasElement, levelDesigner: LevelDesignerComponent, toolGroup: ToolGroup) {
        super(canvas, levelDesigner, toolGroup, ToolType.Toggle, 'assets/icons/snapping.svg');

        this.moveManager = levelDesigner.managers.find(m => m instanceof MoveManager) as MoveManager;
        
        this.activate();
    }

    public override getName(): string {
        return 'Toggle Snapping';
    }

    public override getTooltip(): string {
        return 'Toggle Grid Snapping';
    }

    public override getButtonWidth(): number {
        return 40;
    }


    public override onActivated(): void {
        if (this.moveManager) {
            (this.moveManager as any).isSnappingEnabled = true;
            this.levelDesigner.redraw();
        }
    }

    public override onDeactivated(): void {
        if (this.moveManager) {
            (this.moveManager as any).isSnappingEnabled = false;
            this.levelDesigner.redraw();
        }
    }

    public override render(ctx: CanvasRenderingContext2D): void {
        // No rendering needed
    }

    public override onKeyPress(key: string): void {
        // No key handling needed
    }
}
